import script from "./TheNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNavbar.vue?vue&type=script&setup=true&lang=js"

import "./TheNavbar.vue?vue&type=style&index=0&id=b1a8af42&lang=scss"

const __exports__ = script;

export default __exports__